
/*
  This file is auto-generated and ignored by git.
  See the jsdocs-related scripts in package.json and pregenerate.js
*/

export default {
  "KButton": {
    "exportName": "default",
    "displayName": "KButton",
    "description": "The KButton component is used to trigger actions",
    "tags": {},
    "props": [
      {
        "name": "text",
        "mixin": {
          "name": "buttonMixin",
          "path": "buttonMixin.js"
        },
        "description": "Button label text",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "appearance",
        "mixin": {
          "name": "buttonMixin",
          "path": "buttonMixin.js"
        },
        "description": "Button appearance: `'raised-button'`, `'flat-button'`, or `'basic-link'`",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'raised-button'"
        }
      },
      {
        "name": "appearanceOverrides",
        "mixin": {
          "name": "buttonMixin",
          "path": "buttonMixin.js"
        },
        "description": "Overrides that will modify the styles sent to `$computedClass` based on `appearance` prop",
        "type": {
          "name": "object"
        },
        "defaultValue": {
          "func": false,
          "value": ""
        }
      },
      {
        "name": "primary",
        "mixin": {
          "name": "buttonMixin",
          "path": "buttonMixin.js"
        },
        "description": "Show as primary rather than secondary style (for `'raised-button'` and `'flat-button'` appearance)",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "disabled",
        "description": "Whether or not button is disabled",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "type",
        "description": "HTML button `type` attribute (e.g. `'submit'`, `'reset'`)",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'button'"
        }
      },
      {
        "name": "hasDropdown",
        "description": "Adds a dropdown arrow - internal use only",
        "tags": {
          "ignore": [
            {
              "description": true,
              "title": "ignore"
            }
          ]
        },
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "icon",
        "description": "If provided, prepends a `KIcon` to the text in the button",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "iconAfter",
        "description": "If provided, appends an `KIcon` to the text in the button",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      }
    ],
    "events": [
      {
        "name": "click",
        "description": "Emitted when the button is triggered",
        "type": {
          "names": [
            "undefined"
          ]
        }
      }
    ],
    "slots": [
      {
        "name": "icon",
        "description": "Slot alternative to the `icon` prop"
      },
      {
        "name": "default",
        "description": "Pass sub-components into the button, which provides more flexibility than and takes precedence over the `text` prop"
      },
      {
        "name": "iconAfter",
        "description": "Slot alternative to the `iconAfter` prop"
      }
    ]
  },
  "KButtonGroup": {
    "displayName": "KButtonGroup",
    "description": "Used to create a consistently spaced horizontal set of buttons and/or links.\n\nKButtonGroup works with KButton, KIconButton, KRouterLink and KExternalLink and any <a> or <button> tags.\nin it's default slot.",
    "tags": {},
    "exportName": "default",
    "slots": [
      {
        "name": "default"
      }
    ]
  },
  "KExternalLink": {
    "exportName": "default",
    "displayName": "KExternalLink",
    "description": "KExternalLink creates a styled external link",
    "tags": {},
    "props": [
      {
        "name": "text",
        "mixin": {
          "name": "buttonMixin",
          "path": "buttonMixin.js"
        },
        "description": "Button label text",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "appearance",
        "mixin": {
          "name": "buttonMixin",
          "path": "buttonMixin.js"
        },
        "description": "Button appearance: `'raised-button'`, `'flat-button'`, or `'basic-link'`",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'basic-link'"
        }
      },
      {
        "name": "appearanceOverrides",
        "mixin": {
          "name": "buttonMixin",
          "path": "buttonMixin.js"
        },
        "description": "Overrides that will modify the styles sent to `$computedClass` based on `appearance` prop",
        "type": {
          "name": "object"
        },
        "defaultValue": {
          "func": false,
          "value": ""
        }
      },
      {
        "name": "primary",
        "mixin": {
          "name": "buttonMixin",
          "path": "buttonMixin.js"
        },
        "description": "Show as primary rather than secondary style (for `'raised-button'` and `'flat-button'` appearance)",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "href",
        "description": "URL string",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "download",
        "description": "Specifies that the file is meant to be downloaded, not displayed in a separate tab.",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "openInNewTab",
        "description": "If provided, opens link in new tab and displays a \"pop out\" icon",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "icon",
        "description": "If provided, shows a KIcon in front of the text",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "iconAfter",
        "description": "If provided, shows a KIcon after the text",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      }
    ],
    "slots": [
      {
        "name": "icon",
        "description": "Slot alternative to the `icon` prop"
      },
      {
        "name": "default",
        "description": "Slot alternative to the `icon` prop"
      },
      {
        "name": "iconAfter",
        "description": "Slot alternative to the `icon` prop"
      }
    ]
  },
  "KIconButton": {
    "displayName": "KIconButton",
    "exportName": "default",
    "description": "",
    "tags": {},
    "props": [
      {
        "name": "icon",
        "description": "Name of icon to display",
        "type": {
          "name": "string"
        },
        "required": true
      },
      {
        "name": "appearance",
        "description": "Button appearance: `'raised-button'` or `'flat-button'`",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'flat-button'"
        }
      },
      {
        "name": "color",
        "description": "Optional hex or rgb[a] color for the button background",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "disabled",
        "description": "Whether or not button is disabled",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "buttonType",
        "description": "HTML button `type` attribute (e.g. `'submit'`, `'reset'`)",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'button'"
        }
      },
      {
        "name": "size",
        "description": "Button size: `'mini'`, `'small'`, `'regular'`, or `'large'`",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'regular'"
        }
      },
      {
        "name": "ariaLabel",
        "description": "`aria-label` attribute",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "tooltip",
        "description": "Tooltip label",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      }
    ]
  },
  "KRouterLink": {
    "exportName": "default",
    "displayName": "KRouterLink",
    "description": "KRouterLink creates a styled router-link",
    "tags": {},
    "props": [
      {
        "name": "text",
        "mixin": {
          "name": "buttonMixin",
          "path": "buttonMixin.js"
        },
        "description": "Button label text",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "appearance",
        "mixin": {
          "name": "buttonMixin",
          "path": "buttonMixin.js"
        },
        "description": "Button appearance: `'raised-button'`, `'flat-button'`, or `'basic-link'`",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'basic-link'"
        }
      },
      {
        "name": "appearanceOverrides",
        "mixin": {
          "name": "buttonMixin",
          "path": "buttonMixin.js"
        },
        "description": "Overrides that will modify the styles sent to `$computedClass` based on `appearance` prop",
        "type": {
          "name": "object"
        },
        "defaultValue": {
          "func": false,
          "value": ""
        }
      },
      {
        "name": "primary",
        "mixin": {
          "name": "buttonMixin",
          "path": "buttonMixin.js"
        },
        "description": "Show as primary rather than secondary style (for `'raised-button'` and `'flat-button'` appearance)",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "to",
        "description": "vue-router link object",
        "type": {
          "name": "object"
        },
        "required": true
      },
      {
        "name": "icon",
        "description": "If provided, shows a `KIcon` with the given name before the text",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "iconAfter",
        "description": "If provided, shows a `KIcon` with the given name after the text",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "replace",
        "description": "Use window.history.replaceState() so navigation will not leave history record",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      }
    ],
    "slots": [
      {
        "name": "icon",
        "description": "Optional slot as alternative to `icon` prop"
      },
      {
        "name": "default",
        "description": "Optional slot as alternative to `text` prop"
      },
      {
        "name": "iconAfter",
        "description": "Optional slot as alternative to `iconAfter` prop"
      }
    ]
  },
  "KContentPlugin": {
    "exportName": "default",
    "displayName": "KContentPlugin",
    "description": "",
    "tags": {}
  },
  "KContentRenderer": {
    "exportName": "default",
    "displayName": "KContentRenderer",
    "description": "",
    "tags": {},
    "props": [
      {
        "name": "files",
        "mixin": {
          "name": "mixin",
          "path": "mixin.js"
        },
        "type": {
          "name": "array"
        },
        "defaultValue": {
          "func": false,
          "value": "[]"
        }
      },
      {
        "name": "file",
        "mixin": {
          "name": "mixin",
          "path": "mixin.js"
        },
        "type": {
          "name": "object"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "itemData",
        "mixin": {
          "name": "mixin",
          "path": "mixin.js"
        },
        "type": {
          "name": "object"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "preset",
        "mixin": {
          "name": "mixin",
          "path": "mixin.js"
        },
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "itemId",
        "mixin": {
          "name": "mixin",
          "path": "mixin.js"
        },
        "type": {
          "name": "string"
        }
      },
      {
        "name": "answerState",
        "mixin": {
          "name": "mixin",
          "path": "mixin.js"
        },
        "type": {
          "name": "object"
        },
        "defaultValue": {
          "func": false,
          "value": ""
        }
      },
      {
        "name": "allowHints",
        "mixin": {
          "name": "mixin",
          "path": "mixin.js"
        },
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "true"
        }
      },
      {
        "name": "extraFields",
        "mixin": {
          "name": "mixin",
          "path": "mixin.js"
        },
        "type": {
          "name": "object"
        },
        "defaultValue": {
          "func": false,
          "value": ""
        }
      },
      {
        "name": "options",
        "mixin": {
          "name": "mixin",
          "path": "mixin.js"
        },
        "type": {
          "name": "object"
        },
        "defaultValue": {
          "func": false,
          "value": ""
        }
      },
      {
        "name": "interactive",
        "mixin": {
          "name": "mixin",
          "path": "mixin.js"
        },
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "true"
        }
      },
      {
        "name": "lang",
        "mixin": {
          "name": "mixin",
          "path": "mixin.js"
        },
        "type": {
          "name": "object"
        },
        "defaultValue": {
          "func": true,
          "value": "() => defaultLanguage"
        }
      },
      {
        "name": "showCorrectAnswer",
        "mixin": {
          "name": "mixin",
          "path": "mixin.js"
        },
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "timeSpent",
        "mixin": {
          "name": "mixin",
          "path": "mixin.js"
        },
        "type": {
          "name": "number"
        },
        "defaultValue": {
          "func": false,
          "value": "0"
        }
      },
      {
        "name": "duration",
        "mixin": {
          "name": "mixin",
          "path": "mixin.js"
        },
        "type": {
          "name": "number"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      }
    ],
    "methods": [
      {
        "name": "checkAnswer",
        "tags": {
          "access": [
            {
              "description": "public",
              "title": "access"
            }
          ]
        }
      }
    ]
  },
  "KFixedGrid": {
    "exportName": "default",
    "displayName": "KFixedGrid",
    "description": "Grid layout with a fixed number of columns",
    "tags": {},
    "props": [
      {
        "name": "numCols",
        "description": "The number of columns. Can be an integer between `2` and `12`",
        "type": {
          "name": "number|string"
        },
        "required": true
      },
      {
        "name": "gutter",
        "description": "The size of column gutters in pixels. If not provided, the gutter is set to `16px`\nif either window dimension is less than `600px`, and set to `24px` otherwise.",
        "type": {
          "name": "number|string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "gridStyle",
        "description": "EXPERIMENTAL: Extra styles to attach to the internal grid DOM node",
        "tags": {
          "ignore": [
            {
              "description": true,
              "title": "ignore"
            }
          ]
        },
        "type": {
          "name": "object"
        },
        "defaultValue": {
          "func": false,
          "value": ""
        }
      },
      {
        "name": "debug",
        "description": "Show gridlines for debugging purposes",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      }
    ],
    "slots": [
      {
        "name": "default",
        "description": "Children of a `KFixedGrid` must be `KFixedGridItem` components"
      }
    ]
  },
  "KFixedGridItem": {
    "exportName": "default",
    "displayName": "KFixedGridItem",
    "description": "Basic fixed grid item",
    "tags": {},
    "props": [
      {
        "name": "span",
        "description": "Number of grid columns that the item should span.\n\nIf not provided, the item will span the full width of the grid.",
        "type": {
          "name": "number|string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "alignment",
        "description": "Horizontal alignment of the item's contents. `'left'`, `'right'`,\nand `'center'` will set `text-align`. `'auto'` will set `dir=\"auto\"`\nfor user-generated content to support bidirectional text.",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'left'"
        }
      }
    ],
    "slots": [
      {
        "name": "default",
        "description": "Contents of the grid item"
      }
    ]
  },
  "KGrid": {
    "exportName": "default",
    "displayName": "KGrid",
    "description": "Grid layout with a dynamic number of columns based on the current window width.\n\nThe grid will have 4 columns for small windows (width < 840px), 8 columns\nfor medium windows (840 px <= width < 960), and 12 columns for large windows\n(960px <=  width)",
    "tags": {},
    "props": [
      {
        "name": "gutter",
        "description": "The size of column gutters in pixels. If not provided, the gutter is set to `16px`\nif either window dimension is less than `600px`, and set to `24px` otherwise.",
        "type": {
          "name": "number|string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "gridStyle",
        "description": "EXPERIMENTAL: Extra styles to attach to the internal grid DOM node",
        "tags": {
          "ignore": [
            {
              "description": true,
              "title": "ignore"
            }
          ]
        },
        "type": {
          "name": "object"
        },
        "defaultValue": {
          "func": false,
          "value": ""
        }
      },
      {
        "name": "debug",
        "description": "Show gridlines for debugging purposes",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      }
    ],
    "slots": [
      {
        "name": "default",
        "description": "Children of a `KFixedGrid` must be `KGridItem` components"
      }
    ]
  },
  "KGridItem": {
    "exportName": "default",
    "displayName": "KGridItem",
    "description": "Responsive grid item used with KGrid.\n\nAccepts \"layout objects\" as props, which can define values for 'span',\n'alignment', or both.\n\nIf no span is defined for a particular layout, the item will span the full\nwidth of the grid.\n\nIf no alignment is defined for a particular layout, the item's contents\nwill be left-aligned. Set `alignment` to `'auto'` to set `dir=\"auto\"`\nfor user-generated content to support bidirectional text.",
    "tags": {},
    "props": [
      {
        "name": "layout",
        "description": "Default layout object, for all grid sizes",
        "type": {
          "name": "object"
        },
        "defaultValue": {
          "func": false,
          "value": ""
        }
      },
      {
        "name": "layout4",
        "description": "Layout object for small, 4-column layouts",
        "type": {
          "name": "object"
        },
        "defaultValue": {
          "func": false,
          "value": ""
        }
      },
      {
        "name": "layout8",
        "description": "Layout object for medium, 8-column layouts",
        "type": {
          "name": "object"
        },
        "defaultValue": {
          "func": false,
          "value": ""
        }
      },
      {
        "name": "layout12",
        "description": "Layout object for large, 12-column layouts",
        "type": {
          "name": "object"
        },
        "defaultValue": {
          "func": false,
          "value": ""
        }
      }
    ],
    "slots": [
      {
        "name": "default",
        "description": "Contents of the grid item"
      }
    ]
  },
  "KBreadcrumbs": {
    "exportName": "default",
    "displayName": "KBreadcrumbs",
    "description": "Used to aid deeply nested navigation of content channels, topics, and resources",
    "tags": {},
    "props": [
      {
        "name": "items",
        "description": "An array of objects, each with a `text` attribute (String) and a\n`link` attribute (vue router link object). The `link` attribute\nof the last item in the array is optional and ignored.",
        "type": {
          "name": "array"
        },
        "required": true
      },
      {
        "name": "showSingleItem",
        "description": "By default, the breadcrums will be hidden when the length of items is 1.\nWhen set to `true`, a breadcrumb will be shown even when there is only one.",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      }
    ]
  },
  "KCheckbox": {
    "displayName": "KCheckbox",
    "description": "Used for toggling boolean user input",
    "tags": {},
    "exportName": "default",
    "props": [
      {
        "name": "label",
        "description": "Text label",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "showLabel",
        "description": "Whether or not to show the label",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "true"
        }
      },
      {
        "name": "checked",
        "description": "Checked state",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "indeterminate",
        "description": "Indeterminate state. Overrides `checked` state",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "disabled",
        "description": "Disabled state",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "description",
        "description": "Description - subtext to the label",
        "type": {
          "name": "string"
        },
        "required": false,
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      }
    ],
    "events": [
      {
        "name": "keydown"
      },
      {
        "name": "change",
        "description": "Emits change event",
        "type": {
          "names": [
            "undefined"
          ]
        },
        "properties": [
          {
            "type": {
              "names": [
                "undefined"
              ]
            },
            "name": "<anonymous1>"
          }
        ]
      },
      {
        "name": "blur",
        "description": "Emits blur event, useful for validation"
      }
    ],
    "methods": [
      {
        "name": "focus",
        "description": "Sets keyboard focus to the checkbox",
        "tags": {
          "access": [
            {
              "description": "public",
              "title": "access"
            }
          ]
        }
      }
    ],
    "slots": [
      {
        "name": "default"
      }
    ]
  },
  "KDropdownMenu": {
    "displayName": "KDropdownMenu",
    "description": "The KDropdownMenu component is used to contain multiple actions",
    "tags": {},
    "exportName": "default",
    "props": [
      {
        "name": "text",
        "description": "Button label text",
        "type": {
          "name": "string"
        },
        "required": true
      },
      {
        "name": "options",
        "description": "An array of options objects, with one object per dropdown item",
        "type": {
          "name": "array"
        },
        "required": true
      },
      {
        "name": "appearance",
        "description": "Button appearance: `'raised-button'` or `'flat-button'`",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'raised-button'"
        }
      },
      {
        "name": "disabled",
        "description": "Whether or not the button is disabled",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "position",
        "description": "The position of the dropdown relative to the button",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'bottom right'"
        },
        "values": [
          "bottom left",
          "bottom center",
          "bottom right",
          "top left",
          "top center",
          "top right",
          "left top",
          "left middle",
          "left bottom",
          "right top",
          "right middle",
          "right bottom"
        ]
      }
    ],
    "events": [
      {
        "name": "select",
        "description": "Emitted when an option is selected",
        "type": {
          "names": [
            "undefined"
          ]
        }
      }
    ]
  },
  "KEmptyPlaceholder": {
    "displayName": "KEmptyPlaceholder",
    "exportName": "default",
    "description": "",
    "tags": {}
  },
  "KLabeledIcon": {
    "displayName": "KLabeledIcon",
    "exportName": "default",
    "description": "",
    "tags": {},
    "props": [
      {
        "name": "label",
        "description": "Text label",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "icon",
        "description": "An icon that will be prepended to the label. Uses the same icon names as the `KIcon` component",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "iconAfter",
        "description": "An icon that will be appended to the label. Uses the same icon names as the `KIcon` component",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "color",
        "description": "If provided, sets the color of the label and any icons that are provided",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "maxWidth",
        "description": "Limits label width to this value",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'100%'"
        }
      }
    ],
    "slots": [
      {
        "name": "icon",
        "description": "Optional slot as alternative to `icon` prop"
      },
      {
        "name": "default",
        "description": "Optional slot as alternative to `label` prop"
      },
      {
        "name": "iconAfter",
        "description": "Optional slot as alternative to `iconAfter` prop"
      }
    ]
  },
  "KModal": {
    "exportName": "default",
    "displayName": "KModal",
    "description": "Used to focus attention on a singular action/task",
    "tags": {},
    "props": [
      {
        "name": "title",
        "description": "The title of the modal",
        "type": {
          "name": "string"
        },
        "required": true
      },
      {
        "name": "submitText",
        "description": "If provided, text of the submit button",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "cancelText",
        "description": "If provided, text of the cancel button",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "submitDisabled",
        "description": "Disable the submit button",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "cancelDisabled",
        "description": "Disable the cancel button",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "size",
        "description": "Width of modal. For consistency use the strings `'small'`, `'medium'`, or `'large'`.\nFor more precise control use an integer number of pixels.",
        "type": {
          "name": "string|number"
        },
        "defaultValue": {
          "func": false,
          "value": "'medium'"
        }
      },
      {
        "name": "hasError",
        "description": "Toggles error message indicator in title",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "errorMessage",
        "type": {
          "name": "string"
        },
        "required": false,
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      }
    ],
    "events": [
      {
        "name": "cancel",
        "description": "Emitted when the cancel button is clicked or the esc key is pressed"
      },
      {
        "name": "submit",
        "description": "Emitted when the submit button or the enter key is pressed"
      }
    ],
    "slots": [
      {
        "name": "default",
        "description": "Main content of modal"
      },
      {
        "name": "actions",
        "description": "Alternative buttons and actions below main content"
      }
    ]
  },
  "KPageContainer": {
    "exportName": "default",
    "displayName": "KPageContainer",
    "description": "",
    "tags": {},
    "props": [
      {
        "name": "noPadding",
        "description": "Whether or not to disable internal container padding",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "topMargin",
        "description": "Value in pixels for top margin",
        "type": {
          "name": "number"
        },
        "defaultValue": {
          "func": false,
          "value": "24"
        }
      }
    ],
    "slots": [
      {
        "name": "default",
        "description": "Contents of the page container"
      }
    ]
  },
  "KRadioButton": {
    "displayName": "KRadioButton",
    "description": "Used to display all options",
    "tags": {},
    "exportName": "default",
    "props": [
      {
        "name": "label",
        "description": "Label text",
        "type": {
          "name": "string"
        },
        "required": true
      },
      {
        "name": "v-model",
        "description": "Component `data` with which to associate this radio button and its siblings",
        "type": {
          "name": "string|number|boolean"
        },
        "required": true
      },
      {
        "name": "value",
        "description": "Unique value that will be assigned to `v-model` data when this radio button is selected",
        "type": {
          "name": "string|number|boolean"
        },
        "required": true
      },
      {
        "name": "description",
        "description": "If provided, description underneath label text",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "disabled",
        "description": "Whether or not the field is disabled",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "autofocus",
        "description": "Whether or not to auto-focus on mount",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      }
    ],
    "events": [
      {
        "name": "keydown",
        "description": "Emitted with `keydown` events",
        "type": {
          "names": [
            "undefined"
          ]
        }
      },
      {
        "name": "change",
        "description": "Emitted on each change with new boolean of button state",
        "type": {
          "names": [
            "undefined"
          ]
        },
        "properties": [
          {
            "type": {
              "names": [
                "undefined"
              ]
            },
            "name": "<anonymous1>"
          }
        ]
      },
      {
        "name": "input",
        "description": "Used to set `value` to `v-model` when checked",
        "type": {
          "names": [
            "undefined"
          ]
        }
      }
    ],
    "methods": [
      {
        "name": "focus",
        "description": "Puts keyboard focus on the radiobutton",
        "tags": {
          "access": [
            {
              "description": "public",
              "title": "access"
            }
          ]
        }
      }
    ],
    "slots": [
      {
        "name": "default",
        "description": "Shown below label text and description"
      }
    ]
  },
  "KResponsiveElementMixin": {
    "exportName": "default",
    "displayName": "KResponsiveElementMixin",
    "description": "",
    "tags": {}
  },
  "KResponsiveWindowMixin": {
    "exportName": "default",
    "displayName": "KResponsiveWindowMixin",
    "description": "",
    "tags": {}
  },
  "KSwitch": {
    "displayName": "KSwitch",
    "exportName": "default",
    "description": "",
    "tags": {},
    "props": [
      {
        "name": "value",
        "description": "Current value of the switch state: on or off",
        "type": {
          "name": "boolean"
        },
        "required": true
      },
      {
        "name": "name",
        "description": "does this need to be exposed?",
        "tags": {
          "ignore": [
            {
              "description": true,
              "title": "ignore"
            }
          ]
        },
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "label",
        "description": "If provided, show a text label next to the switch",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "tabindex",
        "description": "does this need to be exposed?",
        "tags": {
          "ignore": [
            {
              "description": true,
              "title": "ignore"
            }
          ]
        },
        "type": {
          "name": "string|number"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "trueValue",
        "description": "might not be used",
        "tags": {
          "ignore": [
            {
              "description": true,
              "title": "ignore"
            }
          ]
        },
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "true"
        }
      },
      {
        "name": "falseValue",
        "description": "might not be used",
        "tags": {
          "ignore": [
            {
              "description": true,
              "title": "ignore"
            }
          ]
        },
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "submittedValue",
        "description": "might not be used",
        "tags": {
          "ignore": [
            {
              "description": true,
              "title": "ignore"
            }
          ]
        },
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'on'"
        }
      },
      {
        "name": "checked",
        "description": "seems redundant with 'value'",
        "tags": {
          "ignore": [
            {
              "description": true,
              "title": "ignore"
            }
          ]
        },
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "color",
        "description": "not used",
        "tags": {
          "ignore": [
            {
              "description": true,
              "title": "ignore"
            }
          ]
        },
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'primary'"
        }
      },
      {
        "name": "switchPosition",
        "description": "not used",
        "tags": {
          "ignore": [
            {
              "description": true,
              "title": "ignore"
            }
          ]
        },
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'left'"
        }
      },
      {
        "name": "disabled",
        "description": "Whether or not the switch is disabled",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      }
    ],
    "events": [
      {
        "name": "input",
        "type": {
          "names": [
            "undefined"
          ]
        },
        "description": "Emitted on each change with new `value`",
        "properties": [
          {
            "type": {
              "names": [
                "undefined"
              ]
            },
            "name": "<anonymous1>"
          }
        ]
      },
      {
        "name": "change",
        "description": "does this need to be exposed?",
        "type": {
          "names": [
            "undefined"
          ]
        },
        "tags": [
          {
            "title": "ignore",
            "content": true
          }
        ],
        "properties": [
          {
            "type": {
              "names": [
                "undefined"
              ]
            },
            "name": "<anonymous1>"
          }
        ]
      },
      {
        "name": "focus",
        "type": {
          "names": [
            "undefined"
          ]
        }
      },
      {
        "name": "blur",
        "type": {
          "names": [
            "undefined"
          ]
        }
      }
    ],
    "slots": [
      {
        "name": "default"
      }
    ]
  },
  "KCircularLoader": {
    "displayName": "KCircularLoader",
    "description": "Used to show indeterminate loading",
    "tags": {},
    "exportName": "default",
    "props": [
      {
        "name": "type",
        "description": "One of `'determinate'` or `'indeterminate'`. Determinate loaders represent a known completion percentage, while indeterminate loaders simply show that activity is currently happening.",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'indeterminate'"
        }
      },
      {
        "name": "progress",
        "description": "For determinate loaders, value between 0 and 100 representing percentage completion",
        "type": {
          "name": "number"
        },
        "defaultValue": {
          "func": false,
          "value": "0"
        }
      },
      {
        "name": "delay",
        "description": "Whether there should be a delay before the loader displays. Useful if the action often takes less than a second or two.",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "size",
        "description": "Overall size of the loader in pixels",
        "type": {
          "name": "number"
        },
        "defaultValue": {
          "func": false,
          "value": "32"
        }
      },
      {
        "name": "stroke",
        "description": "Stroke width of the loader in pixels",
        "type": {
          "name": "number"
        },
        "defaultValue": {
          "func": false,
          "value": "4"
        }
      }
    ]
  },
  "KLinearLoader": {
    "displayName": "KLinearLoader",
    "description": "Used to show determinate or indeterminate loading",
    "tags": {},
    "exportName": "default",
    "props": [
      {
        "name": "type",
        "description": "One of `'determinate'` or `'indeterminate'`. Determinate loaders represent a known completion percentage, while indeterminate loaders simply show that activity is currently happening.",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'indeterminate'"
        }
      },
      {
        "name": "progress",
        "description": "For determinate loaders, value between 0 and 100 representing percentage completion",
        "type": {
          "name": "number"
        },
        "defaultValue": {
          "func": false,
          "value": "0"
        }
      },
      {
        "name": "delay",
        "description": "Whether there should be a delay before the loader displays. Useful if the action often takes less than a second or two.",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      }
    ]
  },
  "KIcon": {
    "displayName": "KIcon",
    "exportName": "default",
    "description": "",
    "tags": {},
    "props": [
      {
        "name": "icon",
        "description": "Icon token identifier",
        "type": {
          "name": "string"
        },
        "required": true
      },
      {
        "name": "color",
        "description": "Color to apply to the icon",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "disableColor",
        "description": "Don't apply automatic fill, allowing external styling.\nCurrently used by the design system itself. Not exposed until we see a broader need",
        "tags": {
          "ignore": [
            {
              "description": true,
              "title": "ignore"
            }
          ]
        },
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      }
    ]
  },
  "KTextbox": {
    "displayName": "KTextbox",
    "description": "Handles user input.",
    "tags": {},
    "exportName": "default",
    "props": [
      {
        "name": "label",
        "description": "Label for the text field",
        "type": {
          "name": "string"
        },
        "required": true
      },
      {
        "name": "value",
        "description": "Value of the text field",
        "type": {
          "name": "string|number"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "invalid",
        "description": "Whether or not the current `value` is invalid",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "invalidText",
        "description": "Text conditionally displayed based on values of `invalid` and `showInvalidText`",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "showInvalidText",
        "description": "Show the `invalidText` even if the user has not focused or change the input.\n`invalid` must also be `true` for this to take effect.",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "disabled",
        "description": "Whether or not the field is disabled",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "autofocus",
        "description": "Whether or not to autofocus",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "maxlength",
        "description": "Maximum number of characters for `value`",
        "type": {
          "name": "number"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "autocomplete",
        "description": "HTML5 autocomplete attribute (`off`, `on`, `name`, `username`, `current-password`, etc)",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "autocapitalize",
        "description": "HTML5 autocapitalize attribute. Used for touch-input enabled UI (`off`, `on`, `words`, etc)",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "type",
        "description": "HTML5 type of input (`text`, `password`, `number`, etc.)",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'text'"
        }
      },
      {
        "name": "min",
        "description": "Minimum value (when `value` type is `number`)",
        "type": {
          "name": "number"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "max",
        "description": "Maximum value (when `value` type is `number`)",
        "type": {
          "name": "number"
        },
        "defaultValue": {
          "func": false,
          "value": "null"
        }
      },
      {
        "name": "textArea",
        "description": "Whether to display as a multi-line text area",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "floatingLabel",
        "description": "Whether or not to display as a floating label.\nThis should not actually be used",
        "tags": {
          "ignore": [
            {
              "description": true,
              "title": "ignore"
            }
          ]
        },
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "true"
        }
      }
    ],
    "events": [
      {
        "name": "input",
        "description": "Emitted on each change with new `value`",
        "type": {
          "names": [
            "undefined"
          ]
        }
      },
      {
        "name": "keydown",
        "description": "Emitted with `keydown` events",
        "type": {
          "names": [
            "undefined"
          ]
        }
      },
      {
        "name": "blur",
        "type": {
          "names": [
            "undefined"
          ]
        }
      },
      {
        "name": "focus",
        "type": {
          "names": [
            "undefined"
          ]
        }
      }
    ],
    "methods": [
      {
        "name": "focus",
        "description": "Puts keyboard focus in the text field",
        "tags": {
          "access": [
            {
              "description": "public",
              "title": "access"
            }
          ]
        }
      }
    ]
  },
  "KTooltip": {
    "displayName": "KTooltip",
    "description": "Used to create a tooltip.",
    "tags": {},
    "exportName": "default",
    "props": [
      {
        "name": "reference",
        "description": "Name of `ref` element within the parent's `$refs` object. Tooltip will be\npositioned relative to this element.",
        "type": {
          "name": "string"
        },
        "required": true
      },
      {
        "name": "refs",
        "description": "Parent's `$refs` object which should contain the named `reference`.",
        "type": {
          "name": "object"
        },
        "required": true
      },
      {
        "name": "disabled",
        "description": "Whether or not tooltip is disabled",
        "type": {
          "name": "boolean"
        },
        "defaultValue": {
          "func": false,
          "value": "false"
        }
      },
      {
        "name": "placement",
        "description": "Placement of tooltip relative to `reference`. Supports any _popper.js_ placement string",
        "type": {
          "name": "string"
        },
        "defaultValue": {
          "func": false,
          "value": "'bottom'"
        }
      }
    ],
    "slots": [
      {
        "name": "default",
        "description": "Text of the tooltip"
      }
    ]
  }
}